module.exports = __webpack_public_path__ + "img/Gorb baron 2.0a8771d1.webp";